import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { auth } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => { const r = await auth.getUser(); setUser(r.data.user); return r.data.user; }, []);
  useEffect(() => { refresh().catch(() => setUser(null)).finally(() => setLoading(false)); }, [refresh]);
  const logout = async () => { try { await auth.logout(); } catch (_) { /* */ } setUser(null); window.location.href = "/login"; };
  const value = useMemo(() => {
    const isAdmin = user?.role === "admin";
    // الأقسام: الأدمن يرى الكل؛ sections = null يعني الكل؛ وإلا القائمة الممنوحة فقط
    const canSee = (key) => !!user && (isAdmin || !Array.isArray(user.sections) || user.sections.includes(key));
    return { user, loading, logout, refresh, isAdmin, canManage: isAdmin || user?.role === "manager", canSee };
  }, [user, loading, refresh]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
